import { render } from "./EditAddressPage.vue?vue&type=template&id=296bac1e&scoped=true&ts=true"
import script from "./EditAddressPage.vue?vue&type=script&lang=ts"
export * from "./EditAddressPage.vue?vue&type=script&lang=ts"

import "./EditAddressPage.vue?vue&type=style&index=0&id=296bac1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296bac1e"]])

export default __exports__